<!--
	描述：星迅的svg图的遥控器弹窗
-->
<template>
	<dialogBody class="addDialogBody" @confirm="confirm" @cancel="cancel" :showCance="showCance" ref="body">
		<template slot="title">
			空调遥控权限设定
		</template>
		<div class="flexStart">
			<p>最低温度:</p>
			<input type="number" min="16" max="30" v-model="minTemperature">
			<p style="margin-right: 20px;">℃</p>
			<p>最高温度:</p>
			<input type="number" min="16" max="30" v-model="maxTemperature">
			<p>℃</p>
		</div>
		<div class="flexStart">
			<p>运行模式:</p>
			<label><input name="runTypeCheckBox" type="checkbox" v-model="runType.t1" disabled /> 关闭 </label>
			<label><input name="runTypeCheckBox" type="checkbox" v-model="runType.t2" disabled /> 自动 </label>
			<label><input name="runTypeCheckBox" type="checkbox" v-model="runType.t3" disabled /> 制冷 </label>
			<label><input name="runTypeCheckBox" type="checkbox" v-model="runType.t4" disabled /> 制热 </label>
			<label><input name="runTypeCheckBox" type="checkbox" v-model="runType.t5" disabled /> 送风 </label>
			<label><input name="runTypeCheckBox" type="checkbox" v-model="runType.t6" disabled /> 除湿 </label>
		</div>
		<div class="flexStart">
			<p>设定风速:</p>
			<label><input name="speedCheckBox" type="checkbox" v-model="speed.t1" disabled /> 自动 </label>
			<label><input name="speedCheckBox" type="checkbox" v-model="speed.t2" disabled /> 低速 </label>
			<label><input name="speedCheckBox" type="checkbox" v-model="speed.t3" disabled /> 中速 </label>
			<label><input name="speedCheckBox" type="checkbox" v-model="speed.t4" disabled /> 高速 </label>
		</div>
		<div class="flexStart">
			<p>垂直风摆:</p>
			<label><input name="verticalCheckBox" type="checkbox" disabled /> 禁止 </label>
			<label><input name="verticalCheckBox" type="checkbox" :checked="true" disabled /> 允许 </label>
		</div>
		<div class="flexStart">
			<p>水平风摆:</p>
			<label><input name="horizontalCheckBox" type="checkbox" disabled /> 禁止 </label>
			<label><input name="horizontalCheckBox" type="checkbox" :checked="true" disabled /> 允许 </label>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from './dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: [],
		data() {
			return {
				minTemperature: 18,
				maxTemperature: 23,
				runType: {
					t1: true,
					t2: true,
					t3: true,
					t4: true,
					t5: true,
					t6: true,
				},
				speed: {
					t1: true,
					t2: true,
					t3: true,
					t4: true,
				},
				vertical: 0,
				horizontal: 0,
				callback: undefined,
				cancelCallBack: undefined,
				prop: [],
				group: undefined,
				operation: undefined,
				timeout: undefined,
				showCance: true
			}
		},
		computed: {},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if (this.callback != undefined) {
					this.callback(this.minTemperature, this.maxTemperature,
						'1,2,4,8,16,32', '1,2,4,8', 1, 1)
				} else {
					//默认执行的内容是调用接口
					this.$api.webSocketApi.airConditionerRight(this.group, this.operation, this.timeout, this.minTemperature, this.maxTemperature,
						'1,2,4,8,16,32', '1,2,4,8', 1, 1, respon => {
							this.$dialogMethod.showMessage("下发成功!")
						})
				}
				this.close()
			},
			cancel() {
				if (this.cancelCallBack != undefined) {
					this.cancelCallBack()
				}
				this.close()
			},
			open(group, operation, timeout, prop, callback, cancelcallback, showCance) {
				this.group = group
				this.operation = operation
				this.timeout = timeout
				this.prop = prop
				this.callback = callback
				this.cancelCallBack = cancelcallback
				this.$refs.body.open()
				if (showCance != undefined) {
					this.showCance = showCance
				}
				if (prop != undefined) {
					//初始化
					for (var i = 0, len = prop.length; i < len; i++) {
						var item = prop[i]
						switch (item.appType) {
							case 280:
								//设定温度
								this.temperature = getValueIfNoNull(item.rtValue, 23)
								break
							case 281:
								//工作模式
								this.runType = getValueIfNoNull(item.rtValue, 0)
								break
							case 282:
								//风速
								this.speed = getValueIfNoNull(item.rtValue, 0)
								break
							case 283:
								//垂直风摆
								this.vertical = getValueIfNoNull(item.rtValue, 0)
								break
							case 284:
								//水平风摆
								this.horizontal = getValueIfNoNull(item.rtValue, 0)
								break
						}
					}
				}
			},
			close() {
				this.$refs.body.hide()
			},
		}
	}
</script>
<style scoped>
	.addDialogBody {
		z-index: 200;
		display: flex;
		align-items: center;
		height: .4rem;
		justify-content: center;
	}

	.addDialogBody>input {
		border: .01rem solid #A9A9A9;
		border-radius: .05rem;
		margin-left: .2rem;
		padding: .02rem .05rem;
		line-height: .25rem;
		width: 2rem;
	}

	.flexStart {
		padding: 10px 0;
	}

	.flexStart label {
		margin-left: 10px;
	}
</style>
